import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import PropTypes from 'prop-types'
import shortid from 'shortid'
import { FONTS } from '../../../../constants'

export const MaximumRow = (props) => {
  const { maximumWorkingHoursPerDay } = props
  let maximum = []
  let total = 0
  const isSubcontract = get(props, 'authData.user.employee_type') === 'Subcontract'
  Object.keys(maximumWorkingHoursPerDay).forEach(s => {
    maximum.push({ date: s, hours: maximumWorkingHoursPerDay[s].hours })
    total += maximumWorkingHoursPerDay[s].hours
  })
  maximum = orderBy(maximum, ['date'], 'asc')

  return (
    <Wrapper>
      <HourText>{ isSubcontract ? 'Maximum Working Hour' : 'Required Working Hour' }</HourText>
      <Column>
        <Total>{ total }</Total>
        {maximum.map(sum => {
          return (
            <Cell key={ shortid() }>
              <Date>{ sum.hours }</Date>
            </Cell>
          )
        })}
      </Column>
    </Wrapper>
  )
}

MaximumRow.propTypes = {
  maximumWorkingHoursPerDay: PropTypes.object,
}
MaximumRow.defaultProps = {
  maximumWorkingHoursPerDay: {},
}

const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const Column = styled.div`
  height: 100%;
  background-color: #EEEEEE;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Date = styled.div`
  color: black;
`
const HourText = styled.div`
  width: 30%;
  margin-left: 1% !important;
  margin-right: 1% !important;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/maximum-row.js